import { loadStripe } from '@stripe/stripe-js';

// Posthog
import ph from '../../../analytics/posthog/posthog-client';

declare let core_object: any;
declare let party_object: any;

const type_stripe: string = core_object.ph_key.type;
const ph_key = (type_stripe == 'test') ? core_object.ph_key.test : core_object.ph_key.live;

// Load Stripe
const stripe = await loadStripe(ph_key);

// Define card elements
let elements; 

let payment_intent_id;

export default class stripeProcessing{

    protected elForm: string;
    protected elFormProcess: string;
    protected elPaymentElement: string;
    protected elLoadingPayment: string;
    protected elPaymentResponse: string;
    protected elPayReinit: string;
    protected elFormBtn: string;
    protected elSpinner: string;
    protected elBtnText: string;

    protected paymentForm: HTMLFormElement;

    // Url Api
    protected url_api_init: string;
    protected url_api_payment_init: string;

    constructor(
        elForm: string,
        el_form_process: string,
        el_payment_element: string,
        el_loading_payment: string,
        el_payment_response: string,
        el_pay_reinit: string,
        elFormBtn: string,
        elSpinner: string,
        elBtnText: string,
    ){
        
        this.elForm = elForm;
        this.elFormProcess = el_form_process;
        this.elPaymentElement = el_payment_element;
        this.elLoadingPayment = el_loading_payment;
        this.elPaymentResponse = el_payment_response;
        this.elPayReinit = el_pay_reinit;
        this.elFormBtn = elFormBtn;
        this.elSpinner = elSpinner;
        this.elBtnText = elBtnText;

        this.paymentForm = document.querySelector(this.elForm) as HTMLFormElement;

        // Url API
        this.url_api_init = party_object.rest_urls.init;
        this.url_api_payment_init = party_object.rest_urls.payment_init;
    
    }

    /**
     * Show form
     */
    showForm(){

        const clientSecretParam = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        this.setProcessing(true);

        if(!clientSecretParam){
            
            this.setProcessing(false);
            
            // Create an instance of the Elements UI library and attach the client secret
            this.initialize();

        }

        // Check the PaymentIntent creation status
        this.checkStatus();

    }

    /**
     * Show a spinner on payment form processing
     * @param isProcessing 
     * @param paymentFrm 
     */
    protected setProcessing(isProcessing: boolean = false){

        const elProcess = document.querySelector(this.elFormProcess) as HTMLElement;

        if(isProcessing == true){
            
            this.paymentForm.classList.add("hidden");
            elProcess?.classList.remove("hidden");

        }else{
            
            this.paymentForm.classList.remove("hidden");
            elProcess?.classList.add("hidden");

        }

    }

    /**
     * Fetch a payment intent and capture the client secret
     */
    async initialize(){
        
        const _that = this;
        
        const { id, clientSecret } = await fetch(this.url_api_payment_init, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                request_type: 'create_payment_intent',
            }),
        }).then((r) => r.json());
        
        const paymentOptions = {
            layout: "accordion",
        };

        const appearance = {
            theme: 'night',
            labels: 'floating'
        };

        if(stripe != null){
            
            elements = stripe.elements({ clientSecret });

            elements.update({
                appearance
            });
        
            const paymentElement = elements.create("payment", paymentOptions);

            paymentElement.mount(this.elPaymentElement);

            paymentElement.on('ready', function(event) {
                
                const elLoading = document.querySelector(_that.elLoadingPayment) as HTMLElement;
                elLoading?.classList.add('hidden');

            });
        
            payment_intent_id = id;

        }

    }

    /**
     * Fetch the PaymentIntent status after payment submission
     * @returns 
     */
    async checkStatus(){
        
        const _that = this;

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );
        
        const customerID = new URLSearchParams(window.location.search).get(
            "customer_id"
        );
        
        if(!clientSecret){
            
            return;

        }

        if(stripe !== null){

            const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
        
            if(paymentIntent){
                
                switch(paymentIntent.status){ 
                    
                    case "succeeded":

                        // Get stored values
                        const get_stored_value = _that.getStoredValue();

                        // Post the transaction info to the server-side script and redirect to the payment status page
                        fetch(this.url_api_payment_init, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                request_type: 'payment_insert',
                                payment_intent: paymentIntent,
                                customer_id: customerID,
                                name: get_stored_value.field_name,
                                surname: get_stored_value.field_surname,
                                email: get_stored_value.field_email,
                                phone: get_stored_value.field_phone,
                                phone_full: get_stored_value.phone_full,
                                phone_country_code: get_stored_value.phone_country_code,
                                room_id: get_stored_value.field_room,
                                party_date: get_stored_value.field_party_date,
                                field_party_time_start: get_stored_value.field_party_time_start,
                                field_party_time_end: get_stored_value.field_party_time_end,
                                privacy_policy: get_stored_value.field_privacy_policy,
                                terms_conditions: get_stored_value.field_terms_conditions,
                            }),
                        })
                        .then(response => response.json())
                        .then(data => {
                            
                            if(data.payment_txn_id !== 0){
                                
                                // Send event to posthog
                                ph.captureDownPartyPurchase(
                                    get_stored_value.field_name,
                                    get_stored_value.field_surname,
                                    get_stored_value.field_email,
                                    get_stored_value.phone_full,
                                    get_stored_value.field_room_name,
                                    get_stored_value.field_party_date,
                                    get_stored_value.field_party_time_start,
                                    get_stored_value.field_party_time_end,
                                );
                                
                                // Revmove stored values
                                _that.removeStoredValue();

                                const url_redirect = party_object.page_complete + '?pid=' + data.payment_txn_id;

                                location.replace(url_redirect);
                                
                            }else{
                                
                                _that.showMessage(data.error);
                                _that.setReinit();
                                
                            }

                        })
                        .catch(console.error);
                        
                    break;
                    
                    case "processing":

                        _that.showMessage(party_object.payment_error_messages.processing);
                        _that.setReinit();

                    break;
                    
                    case "requires_payment_method":

                        _that.showMessage(party_object.payment_error_messages.payment_failed);
                        _that.setReinit();

                    break;
                    
                    default:

                        _that.showMessage(party_object.payment_error_messages.general);
                        _that.setReinit();

                    break;
                    
                }
            }else{

                _that.showMessage(party_object.payment_error_messages.general);
                _that.setReinit();

            }
            
        }

    }

    /**
     * Form submit handler
     */
    handleSubmit(
        field_name: string,
        field_surname: string,
        field_email: string,
        field_phone: string,
        phone_full: string,
        phone_country_code: string,
        field_room: string,
        field_room_name: string,
        field_party_date: string,
        field_party_time_start: string,
        field_party_time_end: string,
    ){
        
        const _that = this;
        
        this.paymentForm.addEventListener("submit", async(e) => {
            
            e.preventDefault();
            
            _that.setLoading(true);

            // Store form values
            _that.setStoredValue(
                field_name,
                field_surname,
                field_email,
                field_phone,
                phone_full,
                phone_country_code,
                field_room,
                field_room_name,
                field_party_date,
                field_party_time_start,
                field_party_time_end,
            );
            
            // Create customer
            const { id, customer_id } = await fetch(party_object.rest_urls.payment_init, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    request_type: 'create_customer',
                    payment_intent_id: payment_intent_id,
                    'customer': {
                        'name': field_name,
                        'surname': field_surname,
                        'email': field_email,
                        'phone': phone_full,
                    },
                }),
            }).then((r) => r.json());

            if(stripe !== null){
                
                const { error } = await stripe.confirmPayment({
                    elements,
                    confirmParams: {

                        // Make sure to change this to your payment completion page
                        return_url: window.location.href + '?customer_id=' + customer_id,
                        
                    },
                });
                
                // This point will only be reached if there is an immediate error when
                // confirming the payment. Otherwise, your customer will be redirected to
                // your `return_url`. For some payment methods like iDEAL, your customer will
                // be redirected to an intermediate site first to authorize the payment, then
                // redirected to the `return_url`.
                if(error.type === "card_error" || error.type === "validation_error"){
                    
                    _that.showMessage(error.message);
        
                }else{
                    
                    _that.showMessage("An unexpected error occured.");
        
                }

            }

            _that.setLoading(false);
            
        });

    }

    /**
     * Get local storage values
     * @returns 
     */
    protected getStoredValue(){
        
        const get_stored_value = localStorage.getItem('party-order');

        let output: any = {
            field_name: '',
            field_surname: '',
            field_email: '',
            field_phone: '',
            phone_full: '',
            phone_country_code: '',
            field_room: '',
            field_room_name: '',
            field_party_date: '',
            field_party_time_start: '',
            field_party_time_end: '',
            field_privacy_policy: 1,
            field_terms_conditions: 1,
        };

        if(get_stored_value){
            
            const userData = JSON.parse(get_stored_value);

            output = {
                field_name: userData.field_name,
                field_surname: userData.field_surname,
                field_email: userData.field_email,
                field_phone: userData.field_phone,
                phone_full: userData.phone_full,
                phone_country_code: userData.phone_country_code,
                field_room: userData.field_room,
                field_room_name: userData.field_room_name,
                field_party_date: userData.field_party_date,
                field_party_time_start: userData.field_party_time_start,
                field_party_time_end: userData.field_party_time_end,
                field_privacy_policy: userData.field_privacy_policy,
                field_terms_conditions: userData.field_terms_conditions
            }
            
        }

        return output;

    }

    /**
     * Store local storage values
     * @param field_name 
     * @param field_surname 
     * @param field_email 
     * @param field_phone 
     * @param phone_full 
     * @param phone_country_code 
     * @param field_room 
     * @param field_room_name
     * @param field_party_date 
     * @param field_party_time_start 
     * @param field_party_time_end 
     */
    protected setStoredValue(
        field_name: string,
        field_surname: string,
        field_email: string,
        field_phone: string,
        phone_full: string,
        phone_country_code: string,
        field_room: string,
        field_room_name: string,
        field_party_date: string,
        field_party_time_start: string,
        field_party_time_end: string,
    ){

        const userObj = {
            field_name: field_name,
            field_surname: field_surname,
            field_email: field_email,
            field_phone: field_phone,
            phone_full: phone_full,
            phone_country_code: phone_country_code,
            field_room: field_room,
            field_room_name: field_room_name,
            field_party_date: field_party_date,
            field_party_time_start: field_party_time_start,
            field_party_time_end: field_party_time_end,
            field_privacy_policy: 1,
            field_terms_conditions: 1,
        }
            
        localStorage.setItem('party-order', JSON.stringify(userObj));
        
    }

    /**
     * Remove local storage values
     */
    protected removeStoredValue(){
        
        localStorage.removeItem('party-order');
        
    }

    /**
     * Display message
     * @param messageText 
     */
    protected showMessage(messageText){

        const messageContainer = document.querySelector(this.elPaymentResponse);

        messageContainer?.classList.remove("hidden");

        if(messageContainer !== null){
            
            messageContainer.textContent = messageText;

        }

        setTimeout(function () {
            
            messageContainer?.classList.add("hidden");

            if(messageContainer !== null){
            
                messageContainer.textContent = "";

            }

        }, 5000);

    }
    
    /**
     * Show a spinner on payment submission
     * @param isLoading 
     */
    protected setLoading(isLoading){
        
        const submitBtn = document.querySelector(this.elFormBtn) as HTMLButtonElement;

        const spinner = document.querySelector(this.elSpinner);

        const buttonText = document.querySelector(this.elBtnText);
        
        if(isLoading){
            
            // Disable the button and show a spinner

            if(submitBtn !== null){
                
                submitBtn.disabled = true;
                spinner?.classList.remove("hidden");
                buttonText?.classList.add("hidden");
                
            }
            
        }else{

            // Enable the button and hide spinner
            if(submitBtn !== null){
                
                submitBtn.disabled = false;
                spinner?.classList.add("hidden");
                buttonText?.classList.remove("hidden");
                
            }

        }

    }

    /**
     * Show payment re-initiate button
     */
    protected setReinit(){
        
        const form = document.querySelector(this.elForm);

        const payReinit = document.querySelector(this.elPayReinit);
        
        form?.classList.add("hidden");
        payReinit?.classList.remove("hidden");

    }

}